import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Home.module.css';
const cover = process.env.PUBLIC_URL + '/images/cover.JPG';
const dp = process.env.PUBLIC_URL + '/images/dp.JPG';

const Home = () => {
  const highlights = [
    {
      icon: "🔒",
      title: "Security Expertise",
      description: "Comprehensive cybersecurity solutions tailored to your needs"
    },
    {
      icon: "🛡️",
      title: "Proven Track Record",
      description: "Successfully protected numerous organizations from cyber threats"
    },
    {
      icon: "🔍",
      title: "Advanced Analysis",
      description: "In-depth security assessments and vulnerability testing"
    },
    {
      icon: "🚀",
      title: "Modern Solutions",
      description: "Cutting-edge security tools and methodologies"
    }
  ];

  return (
    <div className={styles.container} id="home">
      <div className={styles.hero}>
        <div className={styles.heroContent}>
          <h1 className={styles.title}>
            <span className={styles.titleMain}>Securing Your</span>
            <span className={styles.titleAccent}>Digital Future</span>
          </h1>
          <p className={styles.subtitle}>
            Expert cybersecurity services to protect your assets from evolving threats
          </p>
          <div className={styles.ctaButtons}>
            <Link to="/services" className={styles.primaryButton}>
              Explore Services
            </Link>
            <Link to="/contact" className={styles.secondaryButton}>
              Get in Touch
            </Link>
          </div>
        </div>
        <div className={styles.heroImage}>
          <img src={cover} alt="Cybersecurity" className={styles.coverImg} />
        </div>
      </div>

      <div className={styles.highlights}>
        {highlights.map((highlight, index) => (
          <div key={index} className={styles.highlightCard}>
            <span className={styles.highlightIcon}>{highlight.icon}</span>
            <h3>{highlight.title}</h3>
            <p>{highlight.description}</p>
          </div>
        ))}
      </div>

      <div className={styles.profile}>
        <div className={styles.profileImage}>
          <img src={dp} alt="Emmanuel's Profile" className={styles.dpImg} />
        </div>
        <div className={styles.profileContent}>
          <h2>About Emmanuel</h2>
          <p>
            As a dedicated Cybersecurity Systems Engineer, I bring extensive experience
            in protecting organizations from cyber threats. My expertise spans across
            penetration testing, security architecture, and threat analysis.
          </p>
          <Link to="/about" className={styles.learnMoreButton}>
            Learn More About Me
          </Link>
        </div>
      </div>

      <div className={styles.callToAction}>
        <h2>Ready to Enhance Your Security?</h2>
        <p>Let's work together to protect your digital assets</p>
        <Link to="/contact" className={styles.contactButton}>
          Schedule a Consultation
        </Link>
      </div>
    </div>
  );
};

export default Home;
